import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { UiModule } from '@freelancer/ui';
import { UserProfileStatsModule } from 'app/user-profile/user-profile-stats/user-profile-stats.module';
import { UserProfileSummaryStatsModalComponent } from './user-profile-summary-stats-modal.component';
import { UserProfileSummaryRatingRedesignModule } from '../user-profile-summary-rating-redesign/user-profile-summary-rating-redesign.module';

@NgModule({
  imports: [
    CommonModule,
    FeatureFlagsModule,
    UiModule,
    UserProfileStatsModule,
    UserProfileSummaryRatingRedesignModule,
  ],
  declarations: [UserProfileSummaryStatsModalComponent],
})
export class UserProfileSummaryStatsModalModule {}
